<template>
    <v-alert
        icon="mdi-account-alert"
        border="top"
        color="secondary"
        dismissible
        prominent
        dark
        >Application requires
        <v-chip small color="secondary darken-2">FAIR PDX</v-chip> and
        <v-chip small color="secondary darken-2">PRIORITY RUSH</v-chip></v-alert
    >
</template>
<script>
export default {
    name: "",
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    updated() {},
    detroyed() {},
    methods: {},
};
</script>

<style scoped>
</style>